<template>
    <div>
        <container :active_path="path" :plate="'云项目'">
            <el-tabs v-model="tabsactive" tab-position="left" @tab-click="changeTabs">
                <el-tab-pane :label="line" :name="line" v-for="(line, index) in typesarr" :key="index">
                    <div class="base-warp">
                        <div class="head">
                            <span v-if="isAllCity">城市：</span>
                            <el-select v-model="selectedCity" v-if="isAllCity" placeholder="请选择" @change="handleCity" class="selector">
                                <el-option v-for="item in cityList" :key="item._id.$oid" :label="item.label" :value="item.label"> </el-option>
                            </el-select>
                            <el-button class="btn" type="primary" size="mini" @click="save()">保存</el-button>
                            <project-article class="btn" @addArticle="addArticle" :city="selectedCity"></project-article>
                        </div>
                        <div class="table-box">
                            <div class="t-warp">
                                <transition-group name="flip-list" tag="div">
                                    <div
                                    draggable="true"
                                    @dragstart="dranstart(item)" 
                                    @dragend="dragend" 
                                    @dragenter="dragenter(item)"
                                    v-for="(item, index) in tabledata"
                                    :key="item._id['$oid']"
                                    class="item-box">
                                        <el-button class="delbtn" type="danger" size="small" icon="el-icon-delete" @click="delArticle(item, index)" circle></el-button>
                                        <el-card class="card-custom" shadow="always" :body-style="{ padding: '0' }">
                                            <div class="img-box">
                                                <el-image class="img" :src="item.thumb_url||item.thumbnail" fit="scale-down" :lazy="true"></el-image>
                                            </div>
                                            <div class="info">
                                                <div class="title">{{item.title}}</div>
                                            </div>
                                        </el-card>
                                    </div>
                                </transition-group>
                            </div>
                            
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            
        </container>
    </div>
</template>

<script>
import Container from '../../../components/container.vue'
import ProjectArticle from '../../../components/project-article.vue'
    export default {
        components: {
            Container, ProjectArticle
        },
        data() {
            return {
                path: '/project/home-article',
                tabsactive: '第一行',
                typesarr: ['第一行', '第二行'],
                tabledata: [],
                infos: [],
                oldNum: 0,
                newNum: 0,
                selectedCity:'武汉',
                isAllCity:true,
                cityList:[]
            }
        },
        mounted () {
            this.getCityList();
            let city = this.$store.getters.getuser.city;
            if(city === '全部'){
            this.isAllCity = true;
            }else{
            this.isAllCity = false;
            this.selectedCity = city;
            }
            this.getTableData();
        },
        methods: {
            changeTabs() {
                this.tabledata = [];
                this.getTableData();
                this.formateInfos();
            },
            delArticle(item, index) {
                this.$confirm('是否确认删除？删除后需保存生效。').then(
                    confirm=>{
                        this.tabledata.splice(index, 1);
                        this.formateInfos();
                        this.$message.success('删除成功！');
                    },
                    cancel=> {
                        this.$message.info('已取消删除');
                    }
                )
            },
            dranstart(value) {
                this.oldNum = value;
            },
            dragend: function() {
                if (this.oldNum != this.newNum) {
                    let oldIndex = this.tabledata.indexOf(this.oldNum);
                    let newIndex = this.tabledata.indexOf(this.newNum);
                    let newItems = [...this.tabledata];
                    // 删除老的节点
                    newItems.splice(oldIndex, 1); 
                    // 在列表中目标位置增加新的节点
                    newItems.splice(newIndex, 0, this.oldNum);
                    // this.items一改变，transition-group就起了作用
                    this.tabledata = [...newItems];
                    this.formateInfos()
                }
            },
            dragenter: function(value) {
                this.newNum = value;
            },
            formateInfos() {
                var datas = this.tabledata;
                var arr = [];
                var i = 0;
                for (var data of datas){
                    var obj = {
                        aid: data._id['$oid'],
                        source: data.source,
                    };
                    arr.push(obj);
                    i++;
                }
                this.infos = arr;
            },
            addArticle(article) {
                this.tabledata.push(article);
                this.formateInfos();
            },
            getTableData() {
                let city = this.selectedCity;
                if(city == '武汉') city = ''
                var params = {
                    types: this.tabsactive,
                    city
                }
                this.$api.getHomeArticleList(params).then(
                    data=>{
                        this.tabledata = data;
                        this.formateInfos();
                    }
                )
            },
            save() {
                let city = this.selectedCity;
                if(city == '武汉') city = ''
                var params = {
                    types: this.tabsactive,
                    info: JSON.stringify(this.infos),
                    city
                }
                this.$api.addHomeArticle(params).then(
                    data=>{
                        this.$message.success(data);
                    }
                )
            },
            getCityList() {
                this.$api.getCityList("").then((data) => {
                  
                    this.cityList = data;
                    console.log(this.cityList,'000');
                });
            },
            handleCity() {
                this.getTableData();
            }
        },
    }
</script>

<style lang="scss" scoped>
.head{
    text-align: right;
    padding: 10px 0;
    width: 100%;
    .btn{
        margin-right: 20px;
        display: inline-block;
    }
}
.selector{
    margin-right: 20px;
}
.table-box{
    padding: 10px;
    .t-warp{
        overflow: hidden;
        .item-box{
            float: left;
            margin-right: 10px;
            margin-bottom: 10px;
            position: relative;
            width: 180px;
            .delbtn{
                position: absolute;
                top: 0;
                right: 0;
                z-index: 10;
            }
            .card-custom{
                position: relative;
                .img-box{
                    width: 180px;
                    height: 120px;
                    .img{
                        width: 180px;
                        height: 120px;
                        background: #f5f7fa;
                    }
                }
                .info{
                    height: 88px;
                    padding: 4px 8px;
                    overflow: hidden;
                    box-sizing: border-box;
                    .title{
                        text-overflow: ellipsis;
                        display: -webkit-box; 
                        -webkit-box-orient: vertical; 
                        -webkit-line-clamp: 4; 
                        overflow: hidden; 
                    }
                }
            }
        }
        
    }
}
</style>